// removed by extract-text-webpack-plugin
module.exports = {"header":"Header_header_1qRCL","minimiseIcon":"Header_minimiseIcon_3K-nT","strechIcon":"Header_strechIcon_31ElP","restoreIcon":"Header_restoreIcon_2EoGT","hideStretchIcon":"Header_hideStretchIcon_1f62V","backIcon":"Header_backIcon_2rq2Z","hideIcon":"Header_hideIcon_3UXqG","defaultCursor":"Header_defaultCursor_2V15U"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Header.css
// module id = 116
// module chunks = 0